import React, { useState } from 'react';
import './Cashier.css';
import '../Buttons.css';
import api from '../../api';

const Cashier = ({ currentSupplier }) => {

    const [searchValue, setSearchValue] = useState("");
    const [lookupResults, setLookupResults] = useState([]);   // list of gardeners
    const [selectedGardener, setSelectedGardener] = useState(null);
    const [orders, setOrders] = useState([]);                 // orders for selected gardener
    const [error, setError] = useState("");

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSearch();
        }
    };

    const handleSearch = async () => {
        if (!searchValue.trim()) {
            setError("Enter gardener name, email, or order ID");
            return;
        }

        try {
            setError("");

            const response = await api.get(`/gardenerOrders/cashier/lookup`, {
                params: {
                    supplierID: currentSupplier.id,
                    query: searchValue
                }
            });

            setLookupResults(response.data);
            setSelectedGardener(null);
            setOrders([]);

        } catch (err) {
            console.error(err);
            setError("No matching gardeners found");
            setLookupResults([]);
            setSelectedGardener(null);
            setOrders([]);
        }
    };

    const handleSelectGardener = async (gardener) => {
        setSelectedGardener(gardener);

        try {
            const res = await api.get(`/gardenerOrders/cashier/orders`, {
                params: {
                    supplierID: currentSupplier.id,
                    gardenerID: gardener.gardenerID
                }
            });

            setOrders(
                Array.isArray(res.data)
                    ? res.data.map(item => ({
                        ...item,
                        substitutionVariety: item.substitutionVariety || ""
                    }))
                    : []
            );
        } catch (err) {
            console.error(err);
            setError("Failed to load orders");
            setOrders([]);
        }
    };

    const allDone = orders.every(item =>
        item.fulfilledChecked ||
        (item.substitutionChecked && item.substitutionVariety?.trim())
    );

    const handleDone = async () => {
        try {
            if (orders.length === 0) {
                alert("No items to fulfill.");
                return;
            }

            const orderID = orders[0].orderID;

            const payload = {
                orderID,
                items: orders.map(item => ({
                    orderItemID: item.orderItemID,
                    substitutionVariety: item.substitutionVariety || ""
                }))
            };

            const response = await api.post('/gardenerOrders/cashier/fulfill', payload);

            if (!response.data?.success) {
                alert("Failed to fulfill order.");
                return;
            }

            alert("Order fulfilled successfully.");
            // Reset cashier screen
            setSelectedGardener(null);
            setOrders([]);
            setLookupResults([]);
            setSearchValue("");


        } catch (err) {
            console.error("Fulfill request failed:", err);
            alert("An error occurred while fulfilling the order.");
        }
    };

    return (
        <div className="add-gardener-form">
            <h2 className="form-heading">{currentSupplier.userName} - {currentSupplier.name}</h2>

            {/* SEARCH BAR */}
            <div className="gardener-form-row">
                <label className="gardener-form-label">Search:</label>
                <input
                    type="text"
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                    onKeyDown={handleKeyDown}
                    placeholder="Enter name, email, or order ID"
                    className="gardener-form-input"
                    autoFocus
                />
                <button className="button" onClick={handleSearch}>Lookup</button>
            </div>

            {error && <div className="error-message">{error}</div>}

            {/* LOOKUP RESULTS */}
            {!selectedGardener && lookupResults.length > 0 && (                <div className="lookup-results">
                    {lookupResults.map(g => (
                        <div
                            key={g.gardenerID}
                            className="lookup-row"
                            onClick={() => handleSelectGardener(g)}
                        >
                            <strong>{g.name}</strong> - {g.email}
                            {g.phone && ` - ${g.phone}`}
                        </div>
                    ))}
                </div>
            )}

            {/* ORDERS FOR SELECTED GARDENER */}
            {selectedGardener && (
                <div className="orders-section">
                    <h3>Order for {selectedGardener.name}</h3>

                    <table className="cashier-table">
                        <thead>
                            <tr>
                                <th></th>
                                <th>Variety</th>
                                <th>Packets</th>
                                <th>Substitution?</th>
                                <th>Fulfilled</th>
                            </tr>
                        </thead>

                        <tbody>
                            {(orders.length === 0 ? [{}] : orders).map((item, index) => (
                                <React.Fragment key={item.orderItemID || index}>

                                    {/* MAIN ROW */}
                                    <tr>
                                        <td>

                                            {(item.substitutionText || item.substitutionNote) && (
                                                <div className="variety-note">
                                                    {item.substitutionText || item.substitutionNote}
                                                </div>
                                            )}
                                        </td>
                                        <td>{item.supplierVariety || ""}</td>
                                        <td>{item.totalPackets} x {item.description || ""}</td>

                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={item.substitutionChecked || false}
                                                disabled={orders.length === 0}
                                                onChange={(e) => {
                                                    const updated = [...orders];
                                                    updated[index].substitutionChecked = e.target.checked;

                                                    if (!e.target.checked) {
                                                        updated[index].substitutionVariety = "";
                                                    }

                                                    setOrders(updated);
                                                }}
                                            />

                                            {item.substitutionChecked && (
                                                <input
                                                    type="text"
                                                    className="sub-variety-input"
                                                    placeholder="Enter substitute variety"
                                                    value={item.substitutionVariety || ""}
                                                    onChange={(e) => {
                                                        const updated = [...orders];
                                                        updated[index].substitutionVariety = e.target.value;
                                                        setOrders(updated);
                                                    }}
                                                />
                                            )}
                                        </td>

                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={item.fulfilledChecked || false}
                                                disabled={orders.length === 0}
                                                onChange={(e) => {
                                                    const updated = [...orders];
                                                    updated[index].fulfilledChecked = e.target.checked;
                                                    setOrders(updated);
                                                }}
                                            />
                                        </td>
                                    </tr>

                                </React.Fragment>
                            ))}
                        </tbody>
                    </table>

                    <button
                        disabled={!allDone}
                        onClick={handleDone}
                    >
                        Done
                    </button>

                </div>
            )}
        </div>
    );
};

export default Cashier;
